module.exports = __webpack_public_path__ + "static/media/kid4.27b6341d.jpg";